import { name, version } from './../../package.json'

// exports info about the package
export default name + '@' + version
export { version }
